import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Snippet from "../snippet.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3 className="flex items-center">
    JavaScript snippet <span className="inline-block border border-blue rounded-sm px-1 py-0.5 text-xs text-blue uppercase font-semibold ml-2">Recommended</span>
    </h3>
    <blockquote>
      <p parentName="blockquote">{`This is the simplest way to get PostHog up and running on your website, and only takes a few minutes to set-up.`}</p>
    </blockquote>
    <h4 {...{
      "id": "add-to-your-website--app"
    }}>{`Add to your website `}{`&`}{` app`}</h4>
    <p>{`Paste this snippet within the `}<inlineCode parentName="p">{`<head>`}</inlineCode>{` tags of your website - ideally just inside the closing `}<inlineCode parentName="p">{`</head>`}</inlineCode>{` tag - on all pages that you wish to track.`}</p>
    <Snippet mdxType="Snippet" />
    <p>{`Be sure to replace `}<inlineCode parentName="p">{`<ph_project_api_key>`}</inlineCode>{` and `}<inlineCode parentName="p">{`<ph_instance_address>`}</inlineCode>{` with your project's values. (You can find the snippet pre-filled with this data in the PostHog app under Project / Settings. `}<em parentName="p">{`(Quick links if you use `}<a parentName="em" {...{
          "href": "https://app.posthog.com/project/settings"
        }}>{`PostHog Cloud US`}</a>{` or `}<a parentName="em" {...{
          "href": "https://eu.posthog.com/project/settings"
        }}>{`PostHog Cloud EU`}</a>{`)`}</em></p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Integrated the snippet?`}</strong>{` Here are some ideas for `}<a parentName="p" {...{
          "href": "/tutorials/next-steps-after-installing"
        }}>{`what to do after you've installed PostHog`}</a>{`, from setting up event capture to building your first dashboard.`}</p>
    </blockquote>
    <h4 {...{
      "id": "what-this-code-does"
    }}>{`What this code does`}</h4>
    <p>{`After adding the snippet to your website, it will automatically start to:`}</p>
    <ul>
      <li parentName="ul">{`Capture `}<inlineCode parentName="li">{`$pageview`}</inlineCode>{` events when a user visits a page`}</li>
      <li parentName="ul">{`Track when users `}<a parentName="li" {...{
          "href": "/docs/user-guides/events#autocapture-event-tracking"
        }}>{`click on links or buttons`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/user-guides/recordings"
        }}>{`Record videos of user sessions`}</a>{` that you can play back (if you've enabled the Session recordings feature, which we highly recommend!)`}</li>
    </ul>
    <h3 {...{
      "id": "tips"
    }}>{`Tips`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Add the snippet on your (marketing) website `}<em parentName="strong">{`and`}</em>{` your application using the same PostHog project.`}</strong>{` That means you'll be able to follow a user from the moment they come onto your website, all the way through sign up and their actual usage of your product.`}</li>
      <li parentName="ul"><strong parentName="li">{`Track users across multiple domains`}</strong>{` by including the same project snippet on all sites you wish to track.`}</li>
      <li parentName="ul"><strong parentName="li">{`Disable tracking sensitive information`}</strong>{` by adding the `}<inlineCode parentName="li">{`ph-no-capture`}</inlineCode>{` class to elements you don't want to track. (We do this automatically for common fields like passwords and credit cards.)`}</li>
    </ul>
    <h3 {...{
      "id": "next-steps"
    }}>{`Next steps`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Add permitted domains in your PostHog project settings`}</strong>{` so you can create `}<a parentName="li" {...{
          "href": "/manual/actions"
        }}>{`actions`}</a>{` using the `}<a parentName="li" {...{
          "href": "/manual/toolbar"
        }}>{`PostHog toolbar`}</a>{` directly on your site - `}<em parentName="li">{`a convenient low-code option`}</em>{`.`}</li>
      <li parentName="ul">{`Send `}<a parentName="li" {...{
          "href": "/docs/integrate/client/js#send-custom-events-with-posthogcapture"
        }}>{`custom events`}</a>{` from your codebase for things like signups, purchases, and more KPIs.`}</li>
    </ul>
    <p>{`The dedicated `}<a parentName="p" {...{
        "href": "/docs/integrate/client/js"
      }}>{`JavaScript library`}</a>{` page has more details about everything you can do with `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      